import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import axios from "axios";
import { API, SITE_URL } from "../config";

let seoCache = null;

const fetchSeoSettings = async () => {
  if (seoCache) return seoCache;
  try {
    const res = await axios.get(`${API}/seo`);
    const map = {};
    res.data.forEach(s => { map[s.page] = s; });
    seoCache = map;
    return map;
  } catch { return {}; }
};

export const clearSeoCache = () => { seoCache = null; };

const SEO = ({
  title,
  description,
  path = "",
  type = "website",
  image = "/og-default.png",
  schema = null,
  noAppendBrand = false,
}) => {
  const [seo, setSeo] = useState({ title, description });

  useEffect(() => {
    fetchSeoSettings().then(settings => {
      const pageSeo = settings[path || "/"];
      if (pageSeo) {
        setSeo({
          title: pageSeo.title || title,
          description: pageSeo.description || description
        });
      }
    });
  }, [path, title, description]);

  const displayTitle = noAppendBrand ? seo.title : `${seo.title} | CtrlAltComplete`;
  const canonicalUrl = SITE_URL + (path || "/");
  const imageUrl = image.startsWith("http") ? image : SITE_URL + image;

  return (
    <Helmet>
      <title>{displayTitle}</title>
      <meta name="description" content={seo.description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={displayTitle} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="CtrlAltComplete" />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:locale" content="en_GB" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={displayTitle} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={imageUrl} />

      {/* Structured Data */}
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
